/**
 * Constants that are shared on the retailer signup popup and step pages
 *
 * @param {Array} STORETYPES // lists storetypes available in GQL
 * @param {Array} YEARLY_TURNOVER // lists options for turnover
 * @param {Array} SELLING_ABOARD_COUNT // lists options for selling abroad
 * @param {Array} BUSINESS_SIZE // lists options for business size
 * @param {object} COMPANY_SETTINGS_DEFAULT // default company picker behavior
 * @param {object} COMPANY_SETTINGS // custom company picker behavior based on country_code
 * @param {object} SIGNUP_STATUSES_MAP // lists the Emuns from GQL and matches with Vue routes user should be redirected to
 */

// CONSTANTS

export const STORETYPES = [
    { icon: 'store-home', value: 'home-living' },
    { icon: 'store-cooking', value: 'kitchen-dining' },
    { icon: 'store-food', value: 'food-and-beverages' },
    { icon: 'store-kids', value: 'kids-baby' },
    { icon: 'store-hair', value: 'health-and-beauty' },
    { icon: 'store-jewerly', value: 'jewelry-accessories' },
    { icon: 'store-book', value: 'stationery' },
    { icon: 'store-shoe', value: 'fashion' },
]

export const YEARLY_TURNOVER = [
    'ZERO',
    'NEW',
    'ZERO_TO_FIFTYTHOUSAND',
    'FIFTYTHOUSAND_TO_ONEHUNDREDTHOUSAND',
    'ONEHUNDREDTHOUSAND_TO_FIVEHUNDREDTHOUSAND',
    'FIVEHUNDREDTHOUSAND_TO_ONEMILLION',
    'ONEMILLION_TO_TENMILLION',
    'TENMILLION_PLUS',
]

export const SELLING_ABOARD_COUNT = [
    'ONE',
    'TWO',
    'THREE',
    'FOUR',
    'FIVE',
    'FIVE_PLUS',
]
export const BUSINESS_SIZE = [
    // 'NEW',
    'ONE_TO_FIVE',
    'FIVE_TO_TWENTYFIVE',
    'TWENTYFIVE_TO_FIFTY',
    'FIFTY_TO_ONEHUNDRED',
    'ONEHUNDRED_TO_TWOHUNDREDFIFTY',
    'TWOHUNDREDFIFTY_TO_FIVEHUNDRED',
    'FIVEHUNDRED_PLUS',
]

export const COMPANY_SETTINGS_DEFAULT = {
    entityName: 'placeholders.entity_name',
    vModelName: 'entityName',
    vatFields: { vat: 'placeholders.vat_number' },
}

export const COMPANY_SETTINGS = {
    default: { ...COMPANY_SETTINGS_DEFAULT },
    BE: {
        ...COMPANY_SETTINGS_DEFAULT,
        vatFields: { vat: 'placeholders.vat_number' },
    },
    DE: {
        ...COMPANY_SETTINGS_DEFAULT,
        vatFields: {
            coc: 'placeholders.handelsregister_number',
            vat: 'placeholders.vat_number',
        },
    },
    NL: {
        ...COMPANY_SETTINGS_DEFAULT,
        vatFields: {
            coc: 'placeholders.coc_number',
            vat: 'placeholders.vat_number',
        },
    },
    ES: {
        ...COMPANY_SETTINGS_DEFAULT,
        vatFields: {
            coc: 'placeholders.cif_number',
            vat: 'placeholders.vat_number',
        },
    },
    FR: {
        ...COMPANY_SETTINGS_DEFAULT,
        vatFields: {
            coc: 'placeholders.siren_number',
            vat: 'placeholders.vat_number',
        },
    },
    GB: {
        ...COMPANY_SETTINGS_DEFAULT,
        vatFields: {
            coc: 'placeholders.coc_number',
            vat: 'placeholders.vat_number',
        },
    },
}

export const SIGNUP_STATUSES_MAP = {
    NEW: 'store-details',
    STEP_1: 'store-details',
    STEP_2: 'business-details',
    STEP_3: 'turnover-details',
    STEP_4: 'user-details',
    STEP_5: 'company-details',
    STEP_6: 'address-details',
    FINISHED: '/backoffice',
}
